export default {
    api:{
        getActionList:{
            url:'/api.php/action/getActionList',
            method:'get',
            // crosUrl:'/api',
            hooks:{
                beforeReq(callback){
                    callback && callback()
                },
                receiveRes(callback){
                    callback && callback()
                },
            }
        },
        getActionInfoByID:{
            url:'/api.php/action/getActionInfoByID',
            method:'get',
            // crosUrl:'/api',
            hooks:{
                beforeReq(callback){
                    callback && callback()
                },
                receiveRes(callback){
                    callback && callback()
                },
            }
        },
        getSmsCode:{
            url:'/api.php/user/getSmsCode',
            method:'get',
            // crosUrl:'/api',
            hooks:{
                beforeReq(callback){
                    callback && callback()
                },
                receiveRes(callback){
                    callback && callback()
                },
            }
        },
    },   
    hooks:{
        beforeContactReq(callback){
            callback && callback()
        },
        receiveContactRes(callback){
            callback && callback()
        }
    }
}